/**
 * AI Voice Agent Platform
 * Desarrollado por Rafael Martinez
 * © 2025 - Todos los derechos reservados
 */

import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import SubscriptionForm from "./components/SubscriptionForm";
import SuccessPage from "./components/SuccessPage";
import PaymentSuccess from "./components/PaymentSuccess";
import AdminLogin from "./components/AdminLogin";
import ClientLogin from "./components/ClientLogin";
import ClientDashboard from "./components/ClientDashboard";
import Dashboard from "./components/Dashboard";
import AdminDashboard from "./components/AdminDashboard";
import PaymentManager from "./components/PaymentManager";
import EmailManager from "./components/EmailManager";
import UserManager from "./components/UserManager";
import Sidebar from "./components/Sidebar";
import PWAInstallButton from "./components/PWAInstallButton";
import "./App.css";

// Componente wrapper para layout del admin
function AdminLayout({ children, onLogout }) {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#0f172a' }}>
      <Sidebar onLogout={onLogout} />
      <div style={{
        marginLeft: '280px',
        flex: 1,
        transition: 'margin-left 0.3s',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {children}
      </div>
    </div>
  );
}

// Componente principal de la app
function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isAdminRoute, setIsAdminRoute] = useState(false);

  useEffect(() => {
    // Verificar si estamos en una ruta de admin o cliente (excepto login)
    const adminRoutes = ['/admin/dashboard', '/admin/users', '/admin/subscriptions', '/admin/payments', '/admin/emails', '/admin/settings'];
    const clientRoutes = ['/client/dashboard'];
    const hideInstallButton = adminRoutes.some(route => location.pathname.startsWith(route)) ||
                               clientRoutes.some(route => location.pathname.startsWith(route));
    setIsAdminRoute(hideInstallButton);
  }, [location]);

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/admin');
  };

  return (
    <div className="App">
      <Routes>
        {/* Rutas públicas */}
        <Route path="/" element={<SubscriptionForm />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/login" element={<ClientLogin />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* Ruta de cliente */}
        <Route path="/client/dashboard" element={<ClientDashboard />} />

        {/* Rutas de admin con Sidebar */}
        <Route
          path="/admin/dashboard"
          element={
            <AdminLayout onLogout={handleLogout}>
              <Dashboard />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/users"
          element={
            <AdminLayout onLogout={handleLogout}>
              <UserManager />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/subscriptions"
          element={
            <AdminLayout onLogout={handleLogout}>
              <AdminDashboard />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/payments"
          element={
            <AdminLayout onLogout={handleLogout}>
              <PaymentManager />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/emails"
          element={
            <AdminLayout onLogout={handleLogout}>
              <EmailManager />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/settings"
          element={
            <AdminLayout onLogout={handleLogout}>
              <div style={{ padding: '40px', color: '#94a3b8', textAlign: 'center' }}>
                <h2>⚙️ Configuración</h2>
                <p>Próximamente...</p>
              </div>
            </AdminLayout>
          }
        />
      </Routes>
      {!isAdminRoute && <PWAInstallButton />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
